module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_fds_jp.517831801f024ac36a87d6ec3fd2fe55.png";